import { render, staticRenderFns } from "./selfStatement.vue?vue&type=template&id=54ce40d7&scoped=true&"
import script from "./selfStatement.vue?vue&type=script&lang=js&"
export * from "./selfStatement.vue?vue&type=script&lang=js&"
import style0 from "./selfStatement.vue?vue&type=style&index=0&id=54ce40d7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce40d7",
  null
  
)

export default component.exports